//@flow

import React from 'react';

import type {ChatServiceType} from '../../../entities';
import WhatsappWebFormatter from './WhatsappWebFormatter';

type Props = {
  message: string,
  chatServiceType?: ChatServiceType,
};

export default function MessageFormatter(props: Props) {
  const {message, chatServiceType} = props;
  switch (chatServiceType) {
    case 'WHATSAPP_WEB':
      return <WhatsappWebFormatter message={message} />;

    default:
      return message;
  }
}
